import { render } from "./teaEvaLessonInfo.vue?vue&type=template&id=3c874c48&scoped=true"
import script from "./teaEvaLessonInfo.vue?vue&type=script&lang=js"
export * from "./teaEvaLessonInfo.vue?vue&type=script&lang=js"

import "./teaEvaLessonInfo.vue?vue&type=style&index=0&id=3c874c48&scoped=true&lang=css"
import "./teaEvaLessonInfo.vue?vue&type=style&index=1&id=3c874c48&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c874c48"]])

export default __exports__